import { useQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter } from 'vue';

import { keys } from '../keys';

export const useInvitations = () => useQuery(keys.invitations.invitations);

export const useInvitation = (
  accountUuid: MaybeRefOrGetter<string>,
  invitationUuid: MaybeRefOrGetter<string>,
  retry = true,
) => useQuery(
  () => ({ ...keys.invitations.invitation(accountUuid, invitationUuid), retry: retry ? undefined : false }),
);

export const useCurrentUserInvitations = () => useQuery(keys.invitations.currentUserInvitations);
